import { SilverbackIframe } from '@amazeelabs/silverback-iframe';
import { buildHtml, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';
import { navigate } from 'gatsby';
import React, { useRef } from 'react';

export function mapWebform(
  input: Omit<
    ParagraphWebformFragment | ParagraphWebformEventFragment,
    '__typename'
  >,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'Webform'> {
  return {
    key: 'Webform',
    input: function useWebform() {
      const rootRef = useRef<HTMLDivElement>(null);
      return [
        {
          Element: ({ buildMessages }) => (
            <div ref={rootRef}>
              <SilverbackIframe
                src={input.formUrl}
                buildMessages={(htmlMessages) =>
                  buildMessages(htmlMessages.map(buildHtml))
                }
                // htmlMessages parameter isn't used because url_message webform
                // confirmation option is disabled on this project.
                className={'webform-initial-height'}
                redirect={(url) => navigate(url)}
                style={{
                  width: '100%',
                  minWidth: '100%',
                }}
                onLoad={(event) => {
                  const element = rootRef.current || event.currentTarget;
                  const rect = element.getBoundingClientRect();
                  if (
                    rect.top < 0 &&
                    // Do not scroll on anchored URLs.
                    !window.location.hash
                  ) {
                    window.scroll({
                      behavior: 'smooth',
                      top:
                        element.offsetTop -
                        // Approximate height of the sticky header.
                        94,
                    });
                  }
                }}
              />
            </div>
          ),
        },
        200,
      ];
    },
  };
}
